import { Easing } from '../../utilities';
const DEFAULT_ITEM_ANIMATION_EASING = Easing.out(Easing.exp);
const DEFAULT_ITEM_ANIMATION_DURATION = 500;
const DEFAULT_ITEM_INNER_SPACE = 6;
const DEFAULT_ITEM_OUTER_SPACE = 6;
const DEFAULT_ITEM_ICON_SIZE = 20;
const DEFAULT_ITEM_LAYOUT_DIRECTION = false;
const DEFAULT_ITEM_CONTAINER_WIDTH = 'fill';
const DEFAULT_CONFIG_ANIMATION = 'iconWithLabel';
const DEFAULT_CONFIG_INACTIVE_OPACITY = 0.75;
const DEFAULT_CONFIG_INACTIVE_SCALE = 0.85;
export { DEFAULT_ITEM_ANIMATION_EASING, DEFAULT_ITEM_ANIMATION_DURATION, DEFAULT_ITEM_INNER_SPACE, DEFAULT_ITEM_OUTER_SPACE, DEFAULT_ITEM_ICON_SIZE, DEFAULT_ITEM_LAYOUT_DIRECTION, DEFAULT_ITEM_CONTAINER_WIDTH, DEFAULT_CONFIG_ANIMATION, DEFAULT_CONFIG_INACTIVE_OPACITY, DEFAULT_CONFIG_INACTIVE_SCALE };
//# sourceMappingURL=constants.js.map